/**
 * PlayVideoOnScroll
 *
 * This class automatically plays or pauses HTML video elements based on their visibility in the viewport.
 * It uses the IntersectionObserver API to observe when the video elements intersect with the viewport.
 * When a video element is at least a certain percentage visible (defined by the threshold), the video plays.
 * Otherwise, the video is paused.
 */
export default class PlayVideoOnScroll {
  constructor() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.5,
      },
    );

    const videos = document.querySelectorAll('video[data-play-on-scroll]');
    videos.forEach((video) => {
      observer.observe(video);
    });
  }
}
